export const pageTitle = title => {
  return (document.title =
    title + ' -  SEEVA - Medical and Healthcare React App');
};
